"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockedIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class LockedIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M9,18 L30,18 L30,33 L9,33 L9,18 Z M20.25,23.79 C20.6955,23.5305 21,23.052 21,22.5 C21,21.672 20.3265,21 19.5,21 C18.672,21 18,21.672 18,22.5 C18,23.052 18.303,23.5305 18.75,23.79 L18.75,27.75 C18.75,28.1625 19.086,28.5 19.5,28.5 C19.9125,28.5 20.25,28.1625 20.25,27.75 L20.25,23.79 Z" }),
                    React.createElement("path", { d: "M24.0002456,18 L24.0002456,13.5002456 C24.0002456,11.0149642 21.9855269,9.00024557 19.5002456,9.00024557 C17.0149642,9.00024557 15.0002456,11.0149642 15.0002456,13.5002456 L15.0002456,18 L12,18 L12,13 C12,9.13400675 15.1340068,6 19,6 L20,6 C23.8659932,6 27,9.13400675 27,13 L27,18 L24.0002456,18 Z" })))));
    }
}
exports.LockedIcon = LockedIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/locked.tsx
// module id = 2149
// module chunks = 0 1 2